import { Route, Redirect } from 'react-router-dom'

const PublicRoutes = ({ component: Component, exact, path, restricted, ...rest }) => {

  // Login placeholder
  const isLogin = localStorage.getItem('token')

  return (
    <Route
      exact={exact}
      path={path}
      render={props => (
        isLogin!==null && restricted ?
          <Redirect to='/home' />
          :
          <Component {...props} />
      )}
      {...rest}
    />
  )
}

export default PublicRoutes